import React from "react";

const TRAILER_IMG = "https://static.prod-images.emergentagent.com/jobs/5d1ffe31-7a83-4d54-81ed-b578fc4706d2/images/de814287f9a3a51a48f37bfa3bb46d640c6048ea54770457d2774627e6b5b21c.jpeg";

export default function TirSimulator({ yuk = {}, cap_palet = 33, cap_koli = 500, height = 96 }) {
  const palet = Math.max(0, yuk.palet || 0);
  const koli = Math.max(0, yuk.koli || 0);
  const paletFill = Math.min(palet, cap_palet);
  const koliBlocks = koli > 0 ? Math.min(20, Math.max(1, Math.ceil(koli / Math.max(1, cap_koli / 20)))) : 0;
  return (
    <div data-testid="tir-simulator">
      <div className="relative w-full overflow-hidden rounded-md border border-slate-700"
        style={{ height, backgroundImage: `url(${TRAILER_IMG})`, backgroundSize: "cover", backgroundPosition: "center" }}
        title="DORSE YÜKLEME TAHMİNİ — MAVİ: PALET (TABAN), YEŞİL: KOLİ (ÜST)">
        <div className="absolute inset-0 bg-slate-950/25" />
        <div className="absolute inset-0 grid p-[5%]" style={{ gridTemplateColumns: "repeat(17,1fr)", gridTemplateRows: "1fr 1fr", gap: "2px" }}>
          {Array.from({ length: 34 }).map((_, i) => (
            <div key={i} className={i < paletFill
              ? "rounded-[2px] bg-blue-500 shadow ring-1 ring-blue-300/50"
              : "rounded-[2px] border border-dashed border-slate-400/25"} />
          ))}
        </div>
        <div className="absolute left-[5%] right-[5%] top-[3%] flex gap-[2px]">
          {Array.from({ length: 20 }).map((_, i) => (
            <div key={i} className={`h-2 flex-1 rounded-sm ${i < koliBlocks ? "bg-emerald-400 shadow" : "bg-transparent"}`} />
          ))}
        </div>
      </div>
      <div className="mt-1 flex flex-wrap items-center gap-x-3 gap-y-0.5 text-[10px] text-slate-400">
        <span className="flex items-center gap-1"><span className="h-2 w-2 rounded-sm bg-blue-500" /> PALET {palet}/{cap_palet}</span>
        <span className="flex items-center gap-1"><span className="h-2 w-2 rounded-sm bg-emerald-400" /> KOLİ {koli}/{cap_koli}</span>
        {yuk.kasa ? <span>KASA {yuk.kasa}</span> : null}
        {palet === 0 && koli === 0 && !yuk.kasa ? <span className="text-slate-500">BOŞ</span> : null}
      </div>
    </div>
  );
}
